export const buildAccountNumber = (
  accountNumberPrefix: string | null,
  accountNumber: string | null,
  accountNumberBankId: string | null
) => {
  let finalAccountNumber = "";
  if (accountNumberPrefix !== null && accountNumberPrefix !== "") {
    finalAccountNumber += `${accountNumberPrefix}-`;
  }
  if (accountNumber !== null && accountNumber !== "") {
    finalAccountNumber += accountNumber;
  }
  if (accountNumberBankId !== null && accountNumberBankId !== "") {
    finalAccountNumber += `/${accountNumberBankId}`;
  }
  return finalAccountNumber;
};
